import { useParams } from "react-router-dom";
import LayoutPage from "../../Components/LayoutPage";
import EditCouponContainer from "./Components/EditCouponContainer";

export default function CouponInfo() {
  const { couponId } = useParams();
  return (
    <LayoutPage
      activeIndex={8}
      navItems={["مدیریت کد تخفیف", `کد تخفیف ${couponId}`]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto"
    >
      <EditCouponContainer />
    </LayoutPage>
  );
}
